import { useEffect, useState } from "react";

const useLocation = () => {
  const [location, setLocation] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const nonNavPermSuccess = (props) => {
    setLocation(props.coords);
  };

  const nonNavPermError = (error) => {
    console.log("Geolocation Error: ", error);
    setError("Error fetching location, ensure location services are enabled!");
  };

  const fetchUserLocation = () => {
    let options = {
      enableHighAccuracy: true,
      timeout: 15000,
      maximumAge: 0,
    };
    navigator.geolocation.getCurrentPosition(
      nonNavPermSuccess,
      nonNavPermError,
      options,
    );
  };

  const getUserLocation = () => {
    if (navigator.permissions) {
      navigator.permissions
        .query({ name: "geolocation" })
        .then(function (result) {
          if (result.state === "granted" || result.state === "prompt") {
            fetchUserLocation();
          } else if (result.state === "denied") {
            setError("Error: Please enable location services!");
          }
          result.onchange = () => {
            fetchUserLocation();
          };
        });
    } else {
      fetchUserLocation();
    }
  };

  useEffect(() => {
    // Clean up async useEffect flag.
    let isSubscribed = true;

    setLoading(true);
    if (!navigator.geolocation) {
      setError("Error: Device does not support location services!");
      setLoading(false);
      return;
    }
    if (isSubscribed) getUserLocation();
    setLoading(false);

    // Cancel subscription to useEffect.
    return () => (isSubscribed = false);

    //eslint-disable-next-line
  }, []);

  return { loading, error, location };
};

export default useLocation;
